import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionService extends BaseProvider {
  inspectionTypes: any = [];
  vehicle: any = {};
  itemToEdit: any = { Id: '' };
  fileToLoad: any;

  private vehicleSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public currentVehicle: Observable<any> = this.vehicleSubject.asObservable();

  private inspectionEditSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public currentInspectionEdit: Observable<any> = this.vehicleSubject.asObservable();

  public formData: {
		[fieldName: string]: string | string[] | number | boolean;
	  } = {};
	

  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public ls: LsHelperService,
    public authService: AuthService,
    public utilsService: UtilsService
  ) {
    super();

    this.baseUrl = 'inspection';
  }


  public updateFormData(): void {
		console.log('this.mainService', this.vehicle)
		this.formData = {
		  'MARCA': this.vehicle.Brand,
		  'MODELO': this.vehicle.Model,
		  'AÑO': this.vehicle.Year,
		  'NÚMERO DE TABLILLA': this.vehicle.LicensePlate
		};
	  }


	
 
  searchInspections(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl +
        '/term/' + params.term +
        '/page/' + params.pageNumber +
        '/size/' + params.pageSize;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            this.list = data.Data;
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  getVehicleByLicensePlate(licensePlate: string, typeOfSearch: number) {
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${this.baseUrl}/vehicle/${licensePlate}/${typeOfSearch}`;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            this.vehicle = data.Data;
            this.vehicleSubject.next(data.Data);
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  

  create(params) {
    console.log('params', params);
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl;

      this.http
        .post(
          this.url,
          params
        )
        .subscribe(
          (data: any) => {
            resolve(data);
          },
          err => { reject(err); }
        );
    });
  }

  update(params, id) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

      this.http.put(this.url, params).subscribe(
        (data: any) => {
          console.log('data inspection', data);
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getInspectionTypes() {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/inspectionTypes';

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            this.inspectionTypes = data.Data;
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  getById(id) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

      this.http.get(this.url).subscribe(
        (data: any) => {
          console.log('itemToEdit', data.Data);
          this.itemToEdit = data.Data;
          this.inspectionEditSubject.next(this.itemToEdit);
          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }


  deleteInspection(inspectionId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/${inspectionId}`;

      this.http.delete(this.url).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }


  public async getPdf(id, fileType: string, autoLoad: boolean): Promise<any> {
    console.log('getPdf');
    const queryParams = new HttpParams()
      .set('fileName', id.toString());
    return await new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + 'userProcessRequirement' + '/file';

      this.http
        .get(this.url, { responseType: 'arraybuffer', params: queryParams })
        .subscribe(
          (data) => {
            const url = this.downLoadFile(data, fileType, autoLoad);
            resolve(url);
          },
          err => { reject(err); }
        );
    });
  }

  downLoadFile(data: any, type: string, autoLoad: boolean) {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    if (autoLoad) {
      this.fileToLoad = url;
    }
    return url;
  }

  uploadInspectionPdfFile(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/file';

      this.http
        .post(
          this.url,
          params
        )
        .subscribe(
          (data: any) => {
            resolve(data.Data);
          },
          err => { reject(err); }
        );
    });
  }

  clearInspectionAndVehicleSubject() {
    this.vehicle = null;
    this.itemToEdit = null;
    this.inspectionEditSubject.complete(); 
    this.inspectionEditSubject = new BehaviorSubject(null); 
    this.currentInspectionEdit = this.inspectionEditSubject.asObservable();

    this.vehicleSubject.complete(); 
    this.vehicleSubject = new BehaviorSubject(null); 
    this.currentVehicle = this.inspectionEditSubject.asObservable();
  }
}
